import { Flex, Stack, Text } from "@mantine/core";
import style from "./feedback-illustration.module.css";
import { useTranslation } from "react-i18next";
import { IconArrowsDiagonalMinimize2 } from "@tabler/icons-react";

const FeedbackIllustration = () => {
    const { t } = useTranslation(["landing-page"]);

    return (
        <div className={style.screenshotWrapper}>
            <Flex columnGap={"1rem"}>
                <Stack spacing={"0.5rem"}>
                    <p className={style.screenshotText}>
                        {t('feedback.paragraph1.before_mark')} <mark className={style.mark}>{t('feedback.paragraph1.marked')}</mark> {t('feedback.paragraph1.after_mark')}
                    </p>

                    <p className={style.screenshotText}>
                        {t('feedback.paragraph2')}
                    </p>

                    <p className={style.screenshotText}>
                        {t('feedback.paragraph3')}
                    </p>
                </Stack>

                <Stack miw={170}>
                    <div
                        style={{
                            marginTop: "10px",
                        }}
                        className={`${style.comment} ${style.commentHeightFull}`}
                    >
                        <div className={style.commentContent}>
                            <p style={{ fontSize: "10px" }}>
                                {t('feedback.comment')}
                            </p>

                            <div className={style.commentSourceWrapper}>
                                <Text fz="9px">{t("feedback.sources_label")}</Text>
                                <div className={style.commentSource}>
                                    <span target="_blank" rel="noreferrer" className={style.commentLink}>
                                        {t('feedback.source1')}
                                    </span>
                                </div>

                                <div className={style.commentSource}>
                                    <span target="_blank" rel="noreferrer" className={style.commentLink}>
                                        {t('feedback.source2')}
                                    </span>
                                </div>

                                <div className={style.commentSource}>
                                    <span target="_blank" rel="noreferrer" className={style.commentLink}>
                                        {t('feedback.source3')}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className={style.minimizeButton}>
                            <Flex justify={"center"} align={"center"}>
                                <IconArrowsDiagonalMinimize2 color="var(--text-off)" size={"1rem"} />
                            </Flex>
                        </div>
                    </div>
                </Stack>
            </Flex>
        </div>
    );
};

export default FeedbackIllustration;
